export const LateralBarOptions = [{key: "user", value: "User"}, {key: "ent", value: "Enterprise"}];
export const LateralBarPages = {
  User: [
    "UserData",
    "UserVerifications",
    "UserPrivacy",
    "UserServices",
    // "SystemUser"
  ],
  UserBlocked: ["UserData", "UserVerifications"],
  Enterprise: [
    "EnterpriseData",
    "EnterpriseVerifications",
    "EnterprisePrivacy",
    "EnterpriseServices",
    "EnterpriseTeam",
    "SystemUser",
    "EnterpriseDelete",
  ],
  EnterpriseBlocked: [
    "EnterpriseData",
  ],
  Services: ["UserServices", "EnterpriseServices"],
};
